import type { Document } from "@contentful/rich-text-types";
import { hasExtendedNewsletterForm } from "@lib/utils/loyalty";
import { useStore } from "@store/index";
import { Formik } from "formik";
import type { Header, Values } from "../../types";
import { getInitialValues } from "../../utils/getInitialValues";
import { getValidationSchema } from "../../utils/getValidationSchema";
import { ExtendedForm } from "./components/extended-form/ExtendedForm";
import { Form } from "./components/form";
import { Wrapper } from "./components/wrapper";

type Props = {
    headers: Header;
    isPending: boolean;
    isSuccess: boolean;
    policyAgreement: Document;
    onSubmit: (values: Values) => Promise<void>;
};

export const SubscriptionForm = ({
    headers,
    isPending,
    isSuccess,
    policyAgreement,
    onSubmit,
}: Props) => {
    const customer = useStore((state) => state.data.me.customer);

    return (
        <Wrapper
            hasExtendedNewsletterForm={hasExtendedNewsletterForm}
            headers={headers}
            isSuccess={isSuccess}
        >
            <Formik
                validationSchema={getValidationSchema({
                    headers,
                    hasPolicyAgreement: Boolean(policyAgreement),
                    hasExtendedNewsletterForm,
                })}
                initialValues={getInitialValues({
                    hasExtendedNewsletterForm,
                    hasPolicyAgreement: Boolean(policyAgreement),
                })}
                onSubmit={onSubmit}
            >
                {() =>
                    hasExtendedNewsletterForm ? (
                        <ExtendedForm
                            name={customer?.firstName}
                            email={customer?.email}
                            isLoading={isPending}
                            policyAgreement={policyAgreement}
                            headers={headers}
                        />
                    ) : (
                        <Form
                            email={customer?.email}
                            isLoading={isPending}
                            policyAgreement={policyAgreement}
                            headers={headers}
                        />
                    )
                }
            </Formik>
        </Wrapper>
    );
};
